<template>
  <se-popup v-if="visible" @close="emit('close')" :classes="'sm:w-[327px] ' + type + '-popup'" :show-close="false">
    <div v-if="icon" class="flex justify-center w-full">
      <div class="popup-icon-bg rounded-full p-20 mt-24">
        <se-icon class="popup-icon" :name="icon" :size="28"/>
      </div>
    </div>
    <p class="text-center py-16 font-semibold">{{question}}</p>
    <slot/>
    <template #footer>
      <div class="flex flex-col">
        <se-button :type="buttonType" size="medium" :loading="loading" :disabled="loading" @click="emit('confirm')">{{ confirmBtnText }}</se-button>
        <se-button type="tertiary" size="medium" :disabled="loading" @click="emit('close')" class="!mx-0 mt-12">Cancel</se-button>
      </div>
    </template>
  </se-popup>
</template>

<script setup lang="ts">
import {withDefaults, computed} from 'vue';
import SeButton from "@/src/shared/ui-kit/button/Button.vue";
import SeIcon from "@/src/shared/ui-kit/icon/Icon.vue";
import SePopup from "@/src/shared/ui-kit/popup/Popup.vue";

const props = withDefaults(defineProps<{
  visible: boolean,
  question: string,
  confirmBtnText?: string,
  type?: "success" | "error",
  icon?: string
  loading?: boolean
}>(), {
  confirmBtnText: "Confirm",
  type: 'success',
  icon: '',
  loading: false,
});

const emit = defineEmits(['close', 'confirm']);

const buttonType = computed(() => props.type === 'success' ? 'primary' : props.type)
</script>

<script lang="ts">
export default {
  name: 'SeConfirmPopup',
};
</script>

<style lang="scss">
.c-popup {
  &.error-popup {
    .popup-icon-bg {
      @apply bg-error-10;
    }
    
    .popup-icon {
      @apply text-error-100;
    }
  }
  &.success-popup {
    .popup-icon-bg {
      @apply bg-primary-10;
    }
    
    .popup-icon {
      @apply bg-primary-140;
    }
  }
}
</style>